import {formaterByteSomLesbarStreng} from "../stoettefunk/byteStørrelseFormatering";

export function formaterByteSomLesbarStrengFilterForInjisering() {
    return [formaterByteSomLesbarStrengFilter];
}

/**
 * Formaterer antall byte som menneske vennlig streng.
 * Delegerer til formaterByteSomLesbarStreng.
 */
export function formaterByteSomLesbarStrengFilter(): Function {
    return function (antallByte: number) {
        return formaterByteSomLesbarStreng(antallByte);
    }
}
    